export default "__VITE_ASSET__e1d5851f__"